import React from 'react';
import PropTypes from 'prop-types';
import Clearfix from 'components/elements/clearfix';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setMenuSelected } from '@redux/actions/menuAction';
import { getList } from 'api/speciesApi';

import SpeciesList from './SpeciesList';
import SpeciesView from './SpeciesView';
import slug from 'constants/slug';

class SpeciesManagement extends React.Component {
  static propTypes = {
    initialValue: PropTypes.object,
    biodiversityID: PropTypes.string.isRequired,
    speciesID: PropTypes.string,
    history: PropTypes.object,
    match: PropTypes.object,
  };

  getDetail = (speciesID) => {
    const { history, biodiversityID } = this.props;
    history.push(
      slug.BIODIVERSITY.DETAIL_WITH_ID +
        biodiversityID +
        '/species?speciesID=' +
        speciesID
    );
  };

  getList = () => {
    const { history, biodiversityID } = this.props;
    history.push(
      slug.BIODIVERSITY.DETAIL_WITH_ID + biodiversityID + '/species'
    );
  };

  render() {
    const { biodiversityID, history, dataList, location } = this.props;
    const search = new URLSearchParams(location.search);
    const speciesID = search.get('speciesID');
    const species = (dataList || []).find((item) => item._id === speciesID);

    if (speciesID)
      return (
        <SpeciesView
          speciesID={speciesID}
          biodiversityID={biodiversityID}
          initialValue={species}
          history={history}
          getList={this.getList}
        />
      );

    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />
        <SpeciesList
          hideRightHeaderContent={true}
          getDetail={this.getDetail}
          biodiversityID={biodiversityID}
          getList={(filter) => {
            return getList({ BiodiversityID: biodiversityID, ...filter });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SpeciesManagement)
);



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityView/SpeciesManagement/index.js